import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://yftpapbsdwplfnjylypp.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlmdHBhcGJzZHdwbGZuanlseXBwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE1MDIwMjQsImV4cCI6MjA4NzA3ODAyNH0.RfrUHz7WEuiKHnhBeC1pxfwFOF7AICwywISW0ff6Fuk'

// Cliente ÚNICO — una sola instancia para todo (queries + realtime)
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
})

// supabaseAdmin apunta al MISMO cliente — NO crear dos instancias
// (dos instancias crean dos WebSockets y pueden causar problemas de conexión)
export const supabaseAdmin = supabase

// Tipos de la base de datos
export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          nombre: string
          rol: 'admin' | 'vendedor'
          activo: boolean
          fecha_creacion: string
        }
        Insert: {
          id?: string
          nombre: string
          rol: 'admin' | 'vendedor'
          activo?: boolean
        }
        Update: Partial<Database['public']['Tables']['profiles']['Insert']>
      }
      clients: {
        Row: {
          id: string
          nombre: string
          zona: string
          direccion: string
          telefono: string
          contacto: string
          created_at: string
        }
        Insert: Omit<
          Database['public']['Tables']['clients']['Row'],
          'id' | 'created_at'
        >
        Update: Partial<Database['public']['Tables']['clients']['Insert']>
      }
      visits: {
        Row: {
          id: string
          vendedor_id: string
          vendedor_nombre: string
          cliente_id: string
          cliente_nombre: string
          zona: string
          tipo_visita: 'cobro' | 'venta' | 'cobro_y_venta' | 'seguimiento'
          fecha: string
          hora_llegada: string | null
          hora_salida: string | null
          tiempo_total: number | null
          ubicacion_llegada: {
            lat: number
            lng: number
            timestamp: string
          } | null
          ubicacion_salida: {
            lat: number
            lng: number
            timestamp: string
          } | null
          cobro: {
            huboCobo: boolean
            montoCobrado: number
            metodoPago: string | null
            numeroFactura: string
            estadoFactura: string
          }
          venta: {
            huboVenta: boolean
            montoVenta: number
            numeroPedido: string
          }
          comentarios: string
          motivo_no_pago: string
          proxima_visita: string | null
          estado: 'en_progreso' | 'completada' | 'cancelada'
          created_at: string
        }
        Insert: Omit<
          Database['public']['Tables']['visits']['Row'],
          'id' | 'created_at'
        >
        Update: Partial<Database['public']['Tables']['visits']['Insert']>
      }
      activity_logs: {
        Row: {
          id: string
          user_id: string
          user_name: string
          action: string
          timestamp: string
          location: { lat: number; lng: number; timestamp: string } | null
          details: string
        }
        Insert: Omit<
          Database['public']['Tables']['activity_logs']['Row'],
          'id' | 'timestamp'
        >
        Update: Partial<Database['public']['Tables']['activity_logs']['Insert']>
      }
    }
  }
}
